if (!customElements.get('live-viewers')) {
  customElements.define(
    'live-viewers',
    class LiveViewers extends HTMLElement {
      connectedCallback() {
        this.countElement = this.querySelector('[data-live-viewers-count]');
        this.minimum = Number.parseInt(this.dataset.min, 10) || 1;
        this.maximum = Number.parseInt(this.dataset.max, 10) || this.minimum;

        if (this.maximum < this.minimum) {
          [this.minimum, this.maximum] = [this.maximum, this.minimum];
        }

        this.updateCount();
        this.timer = window.setInterval(() => this.updateCount(), Number.parseInt(this.dataset.interval, 10) || 8000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      updateCount() {
        if (!this.countElement) return;
        this.countElement.textContent = Math.floor(Math.random() * (this.maximum - this.minimum + 1)) + this.minimum;
      }
    }
  );
}
